import { Module } from 'vuex';
import { mutations } from './mutations';
import { actions } from './actions';
import { QueryState } from './types';
import { RootState } from '../types';

export const state: QueryState = {
  checkInDate: new Date(),
  checkOutDate: new Date(),
  adults: 2,
  children: [],
};

const namespaced = true;

export const query: Module<QueryState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
};
